import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import IntlMessages from 'utils/intl-messages';

interface PageTitleBarProps {
  title?: string;
  location: {
    pathname: string;
  };
}

interface BreadcrumbItem {
  title: string;
  link?: string;
}

const PageTitleBar: React.FC<PageTitleBarProps> = (props) => {
  const { push, goBack } = useHistory();

  const breadcrumbHandler = (link?: string) => {
    link === 'goBack' ? goBack() : link && push(link);
  };

  const { title, location } = props;
  const currentPath = location.pathname;
  const path = currentPath.substr(5);
  const res = path.split('/');

  const isProfile = res.includes('profile');
  const isTicket = res.includes('ticket');
  const isList = res.includes('list');
  const isAdd = res.includes('add');
  const isEdit = res.includes('edit');
  const isApprove = res.includes('approve');
  const isUsers = res.includes('users');
  const isBranch = res.includes('branch');
  const isEmployees = res.includes('employees') && !res.includes('adminEmployees');
  const restaurantSuppliers = res.includes('restaurants') && res.includes('branch') && res.includes('suppliers');
  const restaurantWarehouse = res.includes('restaurants') && res.includes('warehouse');
  const restaurantWarehouseUsers = res.includes('restaurants') && res.includes('warehouse') && res.includes('users');
  const restaurantWarehouseProducts =
    res.includes('restaurants') && res.includes('warehouse') && res.includes('products');
  const restaurantWarehouseSuppliers =
    res.includes('restaurants') && res.includes('warehouse') && res.includes('suppliers');
  const isProducts = res.includes('suppliers') && res.includes('products');
  const isBranches = res.includes('branch');
  const isBranchUsers = res.includes('branch') && res.includes('users') && res.length > 3;
  const isResBranches = res.includes('branches');
  const isResOrdersList = res.includes('orders-list');
  const isKpi = res.includes('kpi');
  const isMerge = res.includes('merge');
  const isOrderDetails = res.includes('details');
  const isRestaurantDetails = res.includes('restaurants') && res.includes('details');
  const isUsersEdit = isUsers && isEdit && res.length > 3;
  const isEmployeesEdit = isEmployees && isEdit && res.length > 3;
  const isEmployeesAdd = isEmployees && isAdd && res.length >= 3;
  const isBranchEdit = isBranches && isEdit && res.length > 3;

  const breadcrumbArray: BreadcrumbItem[] = isProfile
    ? [{ title: res[0] }]
    : isBranchEdit
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: 'branches', link: 'goBack' }, { title: res[2] }]
    : isUsersEdit
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: 'user', link: 'goBack' }, { title: res[2] }]
    : isBranchUsers
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: 'branches', link: 'goBack' }, { title: res[2] }]
    : isEmployeesEdit
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: 'employee', link: 'goBack' }, { title: res[2] }]
    : isEmployeesAdd
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: 'employee', link: 'goBack' }, { title: res[2] }]
    : restaurantSuppliers
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1], link: 'goBack' }, { title: res[2] }]
    : restaurantWarehouseUsers
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1], link: 'goBack' }, { title: res[2] }]
    : restaurantWarehouseProducts
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1], link: 'goBack' }, { title: res[2] }]
    : restaurantWarehouseSuppliers
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1], link: 'goBack' }, { title: res[2] }]
    : restaurantWarehouse
    ? [
        { title: res[0], link: `/app/${res[0]}` },
        { title: res[1], link: 'goBack' },
      ]
    : isList
    ? [{ title: res[0] }]
    : isAdd
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isEdit
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isApprove
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isBranch
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isResBranches
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isResOrdersList
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isMerge
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isUsers
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isEmployees
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isProducts
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isKpi
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : isRestaurantDetails
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: `${res[0]}.${res[1]}` }]
    : isTicket
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: 'ticket-' + res[1] }]
    : isOrderDetails
    ? [{ title: res[0], link: `/app/${res[0]}` }, { title: res[1] }]
    : [];

  return (
    <div className={`breadcrumbTitle d-flex justify-content-between align-items-center`}>
      {title ? (
        <div className='page-title-wrap'>
          {breadcrumbArray.length > 1 ? (
            <Breadcrumbs separator='/' aria-label='breadcrumb'>
              {breadcrumbArray.map((item, index) => {
                return index !== breadcrumbArray.length - 1 ? (
                  <Link onClick={() => breadcrumbHandler(item.link)} key={index}>
                    <Typography className='secondItem'>
                      <IntlMessages id={`breadcrumb.${item.title}`} />
                    </Typography>
                  </Link>
                ) : (
                  <Typography className='firstItem' key={index}>
                    <IntlMessages id={`${item.title}.breadcrumb`} />
                  </Typography>
                );
              })}
            </Breadcrumbs>
          ) : (
            <Typography color='primary' className='firstItem'>
              {<IntlMessages id={title} />}
            </Typography>
          )}
        </div>
      ) : (
        <div className='page-title-wrap'>
          <h2 className=''>
            <IntlMessages id={title} />
          </h2>
        </div>
      )}
    </div>
  );
};

export default PageTitleBar;
